import React, { useState, useEffect } from "react";
import { auth, firestore, storage } from "./firebase"; // Import storage for image upload
import { updateProfile } from "firebase/auth";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { useNavigate } from "react-router-dom";
import "./Profile.css";
import Veri from "./assets/VerifiedTransaction.png";
import BellIcon from "./assets/bellIcon.svg";
import BottomBar from "./BottomBar/BottomBar";
import TransactionIcon from "./assets/bellIcon.svg";
import BalanceIcon from "./assets/SignUpIcon/creditCard.svg";
import Arroww from "./assets/arroww.svg";
import { onAuthStateChanged } from "firebase/auth";

const Profile = () => {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [photoURL, setPhotoURL] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const userDocRef = doc(firestore, "users", user.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          const data = userDoc.data();
          setUserData(data);
          setUsername(data.username);
          setEmail(data.email);
          setPhotoURL(data.photoURL || "");
          setBalance(data.balance || 0);
          setTransactions(data.transactions || []);
        }
      } else {
        navigate("/");
      }
      setLoading(false);
    });

    return () => unsubscribe();
  }, [navigate]);

  const refreshUserData = async () => {
    const userDoc = await getDoc(doc(firestore, "users", auth.currentUser.uid));
    if (userDoc.exists()) {
      const data = userDoc.data();
      setUserData(data);
      setUsername(data.username);
      setEmail(data.email);
      setPhotoURL(data.photoURL || "");
    }
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = auth.currentUser;
        if (user) {
          const userDocRef = doc(firestore, "users", user.uid);
          const userDoc = await getDoc(userDocRef);
          if (userDoc.exists()) {
            const data = userDoc.data();
            setUserData(data);
            setUsername(data.username);
            setEmail(data.email);
            setPhotoURL(data.photoURL || "");
            setBalance(data.balance || 0); // Fetching user balance
            setTransactions(data.transactions || []); // Fetching user transaction history
          }
        } else {
          navigate("/");
        }
      } catch (error) {
        console.error("Error fetching user data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate]);

  const handleProfileImageChange = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const user = auth.currentUser;
        const storageRef = ref(storage, `profileImages/${user.uid}`);
        const snapshot = await uploadBytes(storageRef, file);
        const downloadURL = await getDownloadURL(snapshot.ref);
        setPhotoURL(downloadURL);

        await updateProfile(user, { photoURL: downloadURL });
        await updateDoc(doc(firestore, "users", user.uid), {
          photoURL: downloadURL,
        });

        await refreshUserData();

        console.log("Profile image uploaded and updated:", downloadURL);
    } catch (error) {
  console.error("Error uploading profile image: ", error.message);
  alert("Upload failed: " + error.message);
}

    }
  };

  const handleUpdateProfile = async (e) => {
    e.preventDefault();
    try {
      const user = auth.currentUser;
      if (user) {
        await updateProfile(user, {
          displayName: username,
          photoURL: photoURL,
        });

        const userDocRef = doc(firestore, "users", user.uid);
        await updateDoc(userDocRef, {
          username: username,
          email: email,
          photoURL: photoURL,
        });

        if (newPassword) {
          await user.updatePassword(newPassword);
        }
        setShowModal(true);
        setModalMessage("Profile updated successfully!");
      }
    } catch (error) {
      console.error("Error updating profile: ", error);
      alert("An error occurred while updating profile. Please try again.");
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setModalMessage("");
  };


  const truncateEmail = (email) => {
  if (!email) return "";
  const [name, domain] = email.split("@");
  const visiblePart = name.slice(0, 4);
  return `${visiblePart}***@${domain}`;
};

const truncateName = (name) => {
  if (!name) return "";
  return name.length > 10 ? `${name.slice(0, 15)}...` : name;
};


  return (
    <div className="profile-container">
      <div className="profileHeaderTop">
        <div className="profileHeaderBtn">
          <button
            onClick={() => navigate("/dashboard")}
            className="profile-imagr"
          >
            <img src={Arroww} alt="back-button" className="profile-imageye" />
          </button>
          <img
            src={photoURL || "default-profile.png"}
            alt="Profile"
            className="profile-imag"
          />
          <p>Your profile</p>
        </div>

        <img src={BellIcon} alt="Bell Icon" />
      </div>
      <div className="profile-header">
        <div className="profile-info">
          <label htmlFor="profile-image-upload">
            <img
              src={photoURL || "default-profile.png"}
              alt="Profile"
              className="profile-image"
            />
          </label>
          <input
            id="profile-image-upload"
            type="file"
            accept="image/*"
            onChange={handleProfileImageChange}
            style={{ display: "none" }}
          />
          <div className="profile-details">
            <p className="greet">Welcome to your profile</p>
<h2 className="username">{truncateName(username)}</h2>
          </div>
        </div>
      </div>

      <div className="account-balance">
        <img src={BalanceIcon} alt="Balance Icon" />
        <div>
          <p className="balance-text">Account Balance</p>
<p className="balance-textt">{truncateEmail(email)}</p>
        </div>
        <h2 className="balance-amount">${balance.toLocaleString()}</h2>
      </div>

      <div className="account-settings">
        <h3>Account Settings</h3>
        {userData ? (
          <form className="profile-form" onSubmit={handleUpdateProfile}>
            <label>Change your Full Name</label>
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />

            <label>Change your Email</label>
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <label>Put new password</label>
            <input
              type="password"
              placeholder="New Password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <button type="submit" className="update-button">
              Update Profile
            </button>
          </form>
        ) : (
          <p>No user data found.</p>
        )}
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-contenttt">
            <img src={Veri} alt="Verified" />
            <p>{modalMessage}</p>
            <span className="close" onClick={closeModal}>
              Okay
            </span>
          </div>
        </div>
      )}

      <div className="back-to-dashboard">
        <a href="/dashboard">Go Back to Dashboard</a>
      </div>

      <BottomBar />
    </div>
  );
};

export default Profile;
